import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Tooltip } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './styles';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Folder from '../../../../Assets/Folder.png'
import Images from '../../../../Assets/assetHelper';
const ITEMS_PER_PAGE = 20;
const FolderContainer: React.FunctionComponent<any> = ({ cardData, onFolderClick }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  console.log(paginatedData, 'cardDatassssss');

  useEffect(() => {
    if (cardData?.length) {
      const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
      const endIndex = startIndex + ITEMS_PER_PAGE;
      setPaginatedData(cardData.slice(startIndex, endIndex));
      setTotalPages(Math.ceil(cardData.length / ITEMS_PER_PAGE));
    } else {
      setPaginatedData([]);
      setTotalPages(1);
    }
  }, [cardData, currentPage]);
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <div className={`  ${classes.networkCardContainer}`} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box className="scrollbarcusgray" width="100%" sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: "auto" }}>
        <Paper className={classes.cardHolder} sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {/* Content Area - Takes remaining space */}
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            <Grid container spacing={1}>
              {paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                    <Paper
                      elevation={2}
                      sx={{
                        borderRadius: 3,
                        padding: 2,
                        backgroundColor: "#F6F8FB",
                        border: "none",
                        boxShadow: "none",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%",
                      }}
                      onClick={() => onFolderClick && onFolderClick(item.id)}
                    >
                      {/* Folder Info */}
                      <Box display="flex" alignItems="center" mb={0.5}>
                        <Typography fontWeight={500} color={"#373A45"} fontSize={14}>{item.title}</Typography>
                      </Box>
                      <Box display="flex" alignItems="center" mb={1}>
                        <Typography fontWeight={400} color={"#373A45"} fontSize={14}>Last updated on: {item?.Lastupdated}</Typography>
                      </Box>
                      {/* Folder Image */}
                      <Box
                        sx={{
                          width: '100%',
                          height: 180,
                          objectFit: 'cover',
                          borderRadius: 2,
                          mb: 1.5,
                          backgroundColor: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <img src={Folder} alt='' height={"80px"} width={"80px"} />
                      </Box>
                      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <Box display="flex" alignItems="center">
                          <img
                            src={item.avatarUrl || Images.Images.DefaultProfileImage}
                            alt={item.userName}
                            style={{ width: 24, height: 24, borderRadius: "50%", marginRight: 8 }}
                          />
                          <Typography
                            fontWeight={500}
                            color="#373A45"
                            fontSize={14}
                            sx={{
                              maxWidth: 120,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.userName && item.userName.length > 15
                              ? `${item.userName.slice(0, 15)}...`
                              : item.userName}
                          </Typography>
                        </Box>
                      </Box>

                    </Paper>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                    <img src={Folder} alt='' height={"80px"} width={"80px"} />
                    <Typography fontWeight={500} color={"#757575"} fontSize={18} ml={2}>
                      No folders found
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            sx={{
              mt: 'auto',
              pt: 2,
              backgroundColor: 'white',
              position: 'sticky',
              bottom: 0,
              zIndex: 1,
            }}
          >
            {cardData.length > ITEMS_PER_PAGE && (
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
                siblingCount={2}
                boundaryCount={1}
                sx={{
                  '& .MuiPaginationItem-root': {
                    borderRadius: '8px',
                    fontWeight: 400,
                    color: '#000',
                    border: '1px solid #E0E0E0',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                    },
                  },
                  '& .MuiPaginationItem-page.Mui-selected': {
                    backgroundColor: '#123A6F',
                    color: '#fff',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: '#123A6F',
                    },
                  },
                  '& .MuiPaginationItem-ellipsis': {
                    color: '#000',
                  },
                  '& .MuiPaginationItem-previousNext': {
                    fontWeight: 400,
                    color: '#000',
                  },
                  '& .MuiPaginationItem-previousNext.Mui-disabled': {
                    color: '#C0C0C0',
                  },
                }}
                showFirstButton={false}
                showLastButton={false}
              />
            )}
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default FolderContainer;
